export default {
    disclaimer: {
        label_default: "Riconosco e accetto che gli articoli che sto ordinando/ricevendo sono proprietà di O-I da utilizzare per attività lavorative correlate a O-I e, come tali, O-I si riserva il diritto di richiedere la restituzione della proprietà al momento della mia cessazione del rapporto con O-I (o prima, se richiesto da O-I).",
        label_type_1: "Confermo che l'autovalutazione per il telelavoro è stata completata in modo accurato e in buona fede e che qualsiasi attrezzatura o arredo fornito dalla sede di O-I o ordinato tramite Gear sarà da me utilizzato per lo scopo del mio lavoro con O-I. Riconosco e accetto che gli articoli che sto ordinando/ricevendo sono di proprietà di O-I e che saranno utilizzati per attività correlate al lavoro, e pertanto O-I si riserva il diritto di richiedere la restituzione della proprietà al momento della mia cessazione del rapporto di lavoro con O-I (o prima, se richiesto da O-I).",
        errors: {
            required: "Si prega di accettare i termini di utilizzo"
        }
    },
    cost_center: {
        label: "Codice del centro di costo",
        placeholder: "Codice del centro di costo",
        cost_center_not_found: "I centri di costo non presenti potrebbero impiegare fino a 24 ore per essere visualizzati. Contatta il Global Service Desk se non visualizzi il centro di costo appropriato.",
        errors: {
            regex: "Codice centro di costo non valido"
        }
    },
    company_code: {
        label: "Codice aziendale"
    },
    cost_center_name: {
        label: "Nome del centro di costo"
    },
    order_note: {
        label: "Nota d'ordine",
        placeholder: "Nota facoltativa per l'approvazione del responsabile",
    },
    send_emails_to_oobo_orderer: {
        "OOBO": "Avvisami in caso di aggiornamenti su questo ordine"
    },
    "dell_banner":{
        label: "A causa di aggiornamenti di sistema Dell, gli ordini Dell effettuati tra il 1° e il 14 agosto 2026 potrebbero subire ritardi significativi nell'elaborazione. Si prega di prevedere tempi di consegna più lunghi durante questo periodo. Grazie per la comprensione."
    }
}